import { Trash2 } from 'lucide-react';
import { Analysis } from '../../types';
import DownloadMenu from '../DownloadMenu';

interface AnalysisActionsProps {
  analysis: Analysis;
  onDelete: (analysis: Analysis) => void;
}

export default function AnalysisActions({ analysis, onDelete }: AnalysisActionsProps) {
  return (
    <>
      <DownloadMenu
        content={analysis.analysis}
        fileName={analysis.fileName}
        compact
      />

      <button
        onClick={(e) => {
          e.stopPropagation();
          onDelete(analysis);
        }}
        className="p-2 rounded-lg text-error-400 hover:text-error-600 hover:bg-error-50 dark:text-error-500 dark:hover:text-error-400 dark:hover:bg-error-900/20 transition-all duration-200"
        title="Excluir análise"
      >
        <Trash2 className="h-5 w-5" />
      </button>
    </>
  );
}
